<template>
  <div
    v-if="isVisible"
    :style="`backdrop-filter: blur(6px); background-color: ${backgroundColorRGBA}; width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: 2147483646;`"
  >
    <v-container class="fill-height align-center justify-center text-center">
      <v-row dense>
        <v-col cols="12">
          <v-progress-circular
            :color="progressColorClass"
            :size="progressSize"
            :width="progressWidth"
            class="mb-6"
            indeterminate
          >
            <v-icon
              v-if="icon"
              :color="iconColorClass"
              :size="iconSize"
            >
              {{ icon }}
            </v-icon>
          </v-progress-circular>
        </v-col>

        <v-col
          v-if="title"
          class="white--text"
          cols="12"
        >
          <h2 v-safe-html="title" />
        </v-col>

        <v-col
          v-if="subTitle"
          cols="12"
        >
          <h5
            v-safe-html="subTitle"
            class="grey--text d-inline-flex"
            style="max-width: 300px"
          />
        </v-col>

        <v-col cols="12">
          <v-btn
            :color="iconColorClass"
            class="mt-10"
            dark
            large
            @click="onRetry"
          >
            {{ buttonTitle }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Socket from '@/api/Socket'

export default {
  name      : 'OfflineModal',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    backgroundColorRGBA: {
      type   : String,
      default: 'rgba(0,0,0,0.75)'
    },
    progressColorClass: {
      type   : String,
      default: 'orange'
    },
    progressSize: {
      type   : Number,
      default: 164
    },
    progressWidth: {
      type   : Number,
      default: 2
    },
    icon: {
      type   : String,
      default: function () {
        return this.$t('Common.Error.Offline.Icon')
      }
    },
    iconSize: {
      type   : Number,
      default: 96
    },
    iconColorClass: {
      type   : String,
      default: 'orange'
    },
    title: {
      type   : String,
      default: function () {
        return this.$t('Common.Error.Offline.Title')
      }
    },
    subTitle: {
      type   : String,
      default: function () {
        return this.$t('Common.Error.Offline.Subtitle')
      }
    },
    buttonTitle: {
      type   : String,
      default: function () {
        return this.$t('Common.Error.Offline.Button')
      }
    },
    visible: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    isVisible() {
      return this.visible
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  activated() {
  },
  deactivated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onRetry() {
      Socket.connect()
      // window.callAS(window.SocketCommand.System.Ping, { commands: [] })
    }
  }
}
</script>

<style scoped>

</style>
